import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom'

//style
import "./css/all.css";	// fa 5.13.0
import './index.css';
//import 'bulma/css/bulma.css';		// npm installed
import './mybulma.css';		        // customized bulma CSS, worked


ReactDOM.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>,
	document.getElementById('root')
)
